<template>
    <div class="cz-header">
        <slot></slot> 
    </div>
</template>
<script>
export default {
    name: "cz-header",
};
</script>
<style scoped>
</style>
